import script from "./AnalyticsConsentBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnalyticsConsentBanner.vue?vue&type=script&setup=true&lang=ts"

import "./AnalyticsConsentBanner.vue?vue&type=style&index=0&id=3ec96161&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec96161"]])

export default __exports__